import i18n, { type Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { TURKIYE_ENABLED } from "../../config/features";
import { ensureLocalePrefix, SUPPORTED_LOCALES } from "../locale";

import commonEn from "../../locales/en/common.json";
import authEn from "../../locales/en/auth.json";
import mainEn from "../../locales/en/main.json";
import settingEn from "../../locales/en/setting.json";
import navigationEn from "../../locales/en/navigation.json";
import profileEn from "../../locales/en/profile.json";
import askHelixaEn from "../../locales/en/askHelixa.json";
import tasksEn from "../../locales/en/tasks.json";
import subscriptionPlansEn from "../../locales/en/subscriptionPlans.json";
import noteDetailEn from "../../locales/en/noteDetail.json";
import legalEn from "../../locales/en/legal.json";
import newFileNoteEn from "../../locales/en/newFileNote.json";
import folderEn from "../../locales/en/folder.json";
import popupsEn from "../../locales/en/popups.json";

import commonTr from "../../locales/tr/common.json";
import authTr from "../../locales/tr/auth.json";
import mainTr from "../../locales/tr/main.json";
import settingTr from "../../locales/tr/setting.json";
import navigationTr from "../../locales/tr/navigation.json";
import profileTr from "../../locales/tr/profile.json";
import askHelixaTr from "../../locales/tr/askHelixa.json";
import tasksTr from "../../locales/tr/tasks.json";
import subscriptionPlansTr from "../../locales/tr/subscriptionPlans.json";
import noteDetailTr from "../../locales/tr/noteDetail.json";
import legalTr from "../../locales/tr/legal.json";
import newFileNoteTr from "../../locales/tr/newFileNote.json";
import folderTr from "../../locales/tr/folder.json";
import popupsTr from "../../locales/tr/popups.json";

export const defaultNS = "common";

const enResources = {
  common: commonEn,
  auth: authEn,
  main: mainEn,
  setting: settingEn,
  navigation: navigationEn,
  profile: profileEn,
  askHelixa: askHelixaEn,
  tasks: tasksEn,
  subscriptionPlans: subscriptionPlansEn,
  noteDetail: noteDetailEn,
  legal: legalEn,
  newFileNote: newFileNoteEn,
  folder: folderEn,
  popups: popupsEn,
};

const trResources = {
  common: commonTr,
  auth: authTr,
  main: mainTr,
  setting: settingTr,
  navigation: navigationTr,
  profile: profileTr,
  askHelixa: askHelixaTr,
  tasks: tasksTr,
  subscriptionPlans: subscriptionPlansTr,
  noteDetail: noteDetailTr,
  legal: legalTr,
  newFileNote: newFileNoteTr,
  folder: folderTr,
  popups: popupsTr,
};

// Withholding the bundle matters as much as withholding the locale list: the
// detector still consults navigator, so if `tr` resources were registered a
// Turkish browser would be served Turkish strings even with the flag off.
const resources: Resource = TURKIYE_ENABLED
  ? { en: enResources, tr: trResources }
  : { en: enResources };

// Redirects to /{locale}/... if the URL doesn't already have a locale segment.
const { locale } = ensureLocalePrefix();
document.documentElement.lang = locale;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    ns: ["common", "auth", "main", "setting", "navigation", "profile", "askHelixa", "tasks", "subscriptionPlans", "noteDetail", "legal", "newFileNote", "folder", "popups"],
    defaultNS,
    fallbackLng: "en",
    // Derived from the locale module so the gate can never be half-applied.
    supportedLngs: [...SUPPORTED_LOCALES],
    load: "languageOnly",
    detection: {
      order: ["path", "localStorage", "navigator"],
      lookupFromPathIndex: 0,
      caches: ["localStorage"],
      lookupLocalStorage: "helixa_language",
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
